const TooltipPriceLabel = ({
  x,
  y,
  price,
  type, // "swingHigh" or "swingLow"
}) => {
  const labelWidth = 40;
  const labelHeight = 20;
  const pointerSize = 6;

  // Adjust Y position to account for label height and pointer
  const isHigh = type === "swingHigh";
  const yOffset = isHigh ? -(labelHeight + pointerSize) : pointerSize;

  return (
    <g transform={`translate(${x - labelWidth / 2}, ${y + yOffset})`}>
      {/* Rectangle with rounded corners */}
      <rect
        width={labelWidth}
        height={labelHeight}
        rx={4}
        ry={4}
        fill="#d5ecfa"
        stroke="#90caf9"
      />

      {/* Pointer triangle */}
      <polygon
        points={
          isHigh
            ? `${labelWidth / 2 - 5},${labelHeight} ${labelWidth / 2 + 5},${labelHeight} ${labelWidth / 2},${labelHeight + pointerSize}`
            : `${labelWidth / 2 - 5},0 ${labelWidth / 2 + 5},0 ${labelWidth / 2},-${pointerSize}`
        }
        fill="#d5ecfa"
        stroke="#90caf9"
      />

      {/* Price Text */}
      <text
        x={labelWidth / 2}
        y={labelHeight / 2 + 4}
        textAnchor="middle"
        fontSize={12}
        fill="black"
        fontWeight="bold"
        fontFamily="Arial"
      >
        {price}
      </text>
    </g>
  );
};

export default TooltipPriceLabel;
